module.exports = __webpack_public_path__ + "img/login-bg.96b8990c.jpg";